export enum PlanType {
  FAMILY = 'FAMILY',
  INDIVIDUAL = 'INDIVIDUAL',
}
